








































































































































import { Component, Mixins } from "vue-property-decorator";
import { ContractsModule } from "@/store/contracts.module";
import FormValidator from "@/mixins/FormValidator";
import { translate } from "@/utils";
import VCleaveInput from "vuetify-cleave";
import { AuthModule } from "@/store/auth.module";

@Component({ components: { VCleaveInput } })
export default class PayDialog extends Mixins(FormValidator) {
  isOpen: boolean = true;
  paySum: number = null as any;
  radios: string = "Qiwi";

  formRef = "pay-qiwi-form";

  $refs: {
    sumInputRef: any;
  };

  public async clickInstr() {
    AuthModule.setShowInstruction(true);
  }

  get isSmartBilling() {
    return this.radios == "SmartBilling";
  }

  get isKaspi() {
    return this.radios == "Kaspi";
  }

  get checkSumRange() {
    if (this.isSmartBilling || this.isKaspi) return false;
    return !!this.paySum && !(this.paySum >= 60 && this.paySum <= 499999);
  }

  get payDetail() {
    if (this.$refs.sumInputRef) {
      this.$refs.sumInputRef.cleave.lastInputValue = "";
      this.$refs.sumInputRef._data.local = "";
    }
    return translate(ContractsModule.payDetail);
  }

  get curDate() {
    return ContractsModule.curPeriod;
  }

  closeDialogPay() {
    ContractsModule.setShowPayDialog(false);
  }

  get showPayDialog() {
    this.paySum = null as any;
    return ContractsModule.showPayDialog;
  }

  set showPayDialog(val: boolean) {
    this.isOpen = val;
    ContractsModule.setShowPayDialog(val);
  }

  loadingPay: boolean = false;

  async makePay() {
    this.loadingPay = true;
    let contractId = "0";
    if (this.$route.params.id) contractId = this.$route.params.id;
    else {
      if (ContractsModule.contracts && ContractsModule.contracts.length > 0)
        contractId = ContractsModule.contracts[0].contract_rid.toString();
    }

    if (this.radios == "Qiwi") {
      await this.payWithQiwi(contractId);
    } else if (this.radios == "SmartBilling") {
      await this.payWithSmartBilling();
    } else if (this.radios == "Kaspi") {
      await this.payWithKaspi();
    } else {
      await this.payWithPayForm(contractId);
    }
    this.loadingPay = false;
  }

  async payWithPayForm(contractId: string) {
    await ContractsModule.getPayformLink({
      contractId: Number.parseInt(contractId),
      invoiceId: ContractsModule.payDetail.bill_id,
      paySum: String((Number(this.paySum) * 100).toFixed(0)),
      commission: Number(15000),
    }).then(() => {
      this.loadingPay = false;
      if (
        ContractsModule.payformLink.payUrl &&
        ContractsModule.payformLink.payUrl != ""
      ) {
        return window.open(ContractsModule.payformLink.payUrl);
      }
    });
  }

  async payWithQiwi(contractId: string) {
    await ContractsModule.getQiwiLink({
      contractId: Number.parseInt(contractId),
      invoiceId: ContractsModule.payDetail.bill_id,
      paySum: Number(this.paySum).toFixed(2),
      BIN: "", //ContractsModule.BINForRating,
      contractNumber: "", //ContractsModule.contractInfo.contract_number,
    }).then(() => {
      this.loadingPay = false;
      if (
        ContractsModule.qiwiLink.payUrl &&
        ContractsModule.qiwiLink.payUrl != ""
      ) {
        return window.open(ContractsModule.qiwiLink.payUrl);
      }
    });
  }

  async payWithKaspi() {
    await ContractsModule.getKaspiLink({
      contractnumber: this.payDetail.contractnumber,
      bin: this.payDetail.bin,
    }).then(() => {
      this.loadingPay = false;
      if (ContractsModule.kaspiLink && ContractsModule.kaspiLink != "") {
        return window.open(ContractsModule.kaspiLink);
      }
    });
  }

  async payWithSmartBilling() {
    await ContractsModule.getSmartBillingLink({
      lang: this.$i18n.locale === "kk" ? "kz" : "ru",
      sid: this.payDetail.region_rid == 1 ? 1245 : 1246,
      account: this.payDetail.contractnumber,
      bin: this.payDetail.bin,
    }).then(() => {
      this.loadingPay = false;
      if (
        ContractsModule.smartBillingLink &&
        ContractsModule.smartBillingLink != ""
      ) {
        return window.open(ContractsModule.smartBillingLink);
      }
    });
  }
}
